import { useEffect, useState } from "react";
import Bugsnag from "@bugsnag/js";
import { useRoomContext, useRoomInfo } from "@livekit/components-react";
import { RoomEvent } from "livekit-client";

export const useLivekitHlsState = () => {
  const [isRecording, setIsRecording] = useState(false);
  const [hlsUrl, setHlsUrl] = useState(null);
  const room = useRoomContext();
  const roomInfo = useRoomInfo();

  const handleMetadataChanged = (metadata: string) => {
    try {
      const parsed = JSON.parse(metadata);
      setHlsUrl(parsed.hlsUrl);
    } catch (error) {
      Bugsnag.notify(
        new Error("LivekitParseRoomMetadataError"),
        function (event) {
          event.severity = "error";
          event.context = window.location.href;
          event.addMetadata("error", { error: error });
        },
      );
      console.error("Failed to parse metadata:", error);
    }
  };

  useEffect(() => {
    if (!room) return;

    setIsRecording(room.isRecording);
    if (roomInfo.metadata) handleMetadataChanged(roomInfo.metadata);

    room.on(RoomEvent.RecordingStatusChanged, recording =>
      setIsRecording(recording),
    );

    room.on(RoomEvent.RoomMetadataChanged, handleMetadataChanged);

    return () => {
      room.off(RoomEvent.RecordingStatusChanged, setIsRecording);
      room.off(RoomEvent.RoomMetadataChanged, handleMetadataChanged);
    };
  }, [room, roomInfo]);

  return {
    hlsUrl: hlsUrl,
    isHlsRunning: !!hlsUrl,
    isRecording: isRecording,
  };
};
